import React, { useState } from 'react'
import { Card, Button, Input, Header, Footer, toggleTheme, ThemeType } from '@scuf/common' //, ToastNotification
import { useHistory } from "react-router-dom"
import { useDispatch } from 'react-redux'

import { login } from '../../actions/authLogin'
import { msgError, removeError } from '../../actions/msgError'
import servicesAuth from '../../services/auth.services'

//import '@scuf/common/honeywell-compact-combined/theme.css'
//import '@scuf/common/honeywell-compact-dark/theme.css'
//import "@scuf/common/honeywell-dark/theme.css";
//import "@scuf/common/honeywell-dark/theme.css";


import './Login.css'

const ReactToastify = require('react-toastify')

const Login = () => {

    const dispatch = useDispatch();

    var logo = 'https://www.honeywell.com/content/dam/honeywell/en-us/images/HON%20logo_200x37.png';
    localStorage.setItem('tituloHeader', "PROCESOS");

    const [user, setUser] = useState('')
    const [pass, setPass] = useState('')
    const [load, setLoad] = useState(false);

    let history = useHistory();
    toggleTheme(ThemeType.Dark);

    const getData = async (e) => {
        e.preventDefault()
        setLoad(true);
        await servicesAuth.login(user, pass).then(
            (response) => {
                setLoad(false);
                if (response.error) {
                    dispatch(msgError(response.error))
                    // messageToast(response.error);
                    return;
                }
                console.log("Login", response.data)
                dispatch(login(response.data))

                setLoad(false)
                dispatch(removeError())
                history.push('/procesos')
            },
            (error) => {
                console.log(error);
                setLoad(false);
            });
    };

    // const messageToast = (title) => {
    //     ReactToastify.toast(<ToastNotification  closeToast={false} title={title}/>)
    // }


    return (
        <>
            <div className="login-page" />
            <div className='mx-auto'>
                <Card>
                    <Header isForge={true} title="WALL DISPLAY" menu={false} >
                    </Header>
                    <Card.Content>
                        <h3 className='mb-3 text-center'>Log In</h3 >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Input
                                className="input-custom"
                                placeholder="Enter in this field"
                                label="Username"
                                value={user}
                                onChange={e => setUser(e)}
                                type="text"
                                fluid={true}
                            />
                            <Input
                                className="input-custom"
                                placeholder="Enter in this field"
                                label="Password"
                                value={pass}
                                onChange={e => setPass(e)}
                                type="password"
                                fluid={true}
                            />
                            <br></br>
                            <Button type="primary"
                                size="small"
                                style={{ marginTop: '10px' }}
                                disabled={load}
                                onClick={getData}
                                content="Log In"
                                actionType="submit"
                                loading={load}
                            />
                        </div>
                    </Card.Content>
                    <Footer copyrightText="Powered by Kairos Mining" style={{ display: 'none' }}>
                        <Footer.Item href="#" >
                            <img
                                src={logo}
                                alt="Logo"
                                style={{ width: '80px', marginRight: '120px' }}
                            />
                        </Footer.Item>
                    </Footer>
                </Card>
            </div>

            <ReactToastify.ToastContainer
                hideProgressBar={true}
                closeOnClick={false}
                closeButton={false}
                newestOnTop={true}
                position="bottom-right"
                toastClassName="toast-notification-wrap"
            />

        </>
    )
}

export default Login
